import React from 'react';
import ReactGA from 'react-ga';

import SectionIcon from '../../icons/SectionIcon';

function DownloadItem({ section }) {
  return (
    <div className="section-selector__card">
      <h3 className={'section-selector__subheading color--' + section.theme}>{section.fullTitle}</h3>
      <p className="section-selector__description">
        {section.description}
      </p>
      {section.theme === 'anesthesia' && (
        <p className="section-selector__description">
          <ReactGA.OutboundLink
            to="/documents/wastage-calculator.xlsx"
            className="section-selector__link"
            eventLabel="Download Wastage Calculator"
            download
            target="_blank"
            rel="noreferrer noopener"
          >
            Download Wastage Calculator
          </ReactGA.OutboundLink>
          <br />
          This calculator is provided to help you understand the amount of wastage that occurs from drugs that are drawn up and not used and to be part of your analysis following the observation. (Pertains to questions 27, 28, 29 and 39)
        </p>
      )}
      <ReactGA.OutboundLink
        to={section.pdf}
        className="button"
        eventLabel={`Download ${section.fullTitle}`}
        download
        target="_blank"
        rel="noreferrer noopener"
      >
        Download PDF
      </ReactGA.OutboundLink>
      <div className="recent-assessments__icon">
        <SectionIcon theme={section.theme} />
      </div>
    </div>
  );
}

export default DownloadItem;



// WEBPACK FOOTER //
// ./src/components/features/splash/DownloadItem.js